import { render, staticRenderFns } from "./PageHeaders.vue?vue&type=template&id=355a80ee&scoped=true"
import script from "./PageHeaders.vue?vue&type=script&lang=js"
export * from "./PageHeaders.vue?vue&type=script&lang=js"
import style0 from "./PageHeaders.vue?vue&type=style&index=0&id=355a80ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a80ee",
  null
  
)

export default component.exports